import { Controller } from "@hotwired/stimulus"

// Multi-day picker for recurring appointments. Renders 7 pill buttons (S/M/T/W/T/F/S);
// each click toggles its `data-day-index` value in a hidden `appointment[days_of_week][]`
// field. When the date input changes, auto-selects the matching day-of-week if no day
// is yet selected (preserves practitioner's manual toggles).
export default class extends Controller {
  static targets = ["pill", "hiddenContainer"]
  static values = { dateInputSelector: String }

  connect() {
    this.element.querySelectorAll('[data-day-index]').forEach((pill) => {
      pill.addEventListener("click", (e) => this.togglePill(e))
    })

    const dateInput = document.querySelector(this.dateInputSelectorValue)
    if (dateInput) {
      dateInput.addEventListener("change", () => this.autoSelectFromDate(dateInput.value))
      if (dateInput.value) {
        this.autoSelectFromDate(dateInput.value)
      }
    }
  }

  togglePill(event) {
    const pill = event.currentTarget
    const dayIndex = parseInt(pill.dataset.dayIndex, 10)
    if (pill.classList.contains("bg-primary-600")) {
      this.deselectDay(dayIndex)
    } else {
      this.selectDay(dayIndex)
    }
  }

  autoSelectFromDate(dateString) {
    if (!dateString) return
    const date = new Date(dateString + "T00:00:00")
    if (isNaN(date.getTime())) return
    const dayIndex = date.getDay()
    if (!this.anyPillSelected()) {
      this.selectDay(dayIndex)
    }
  }

  anyPillSelected() {
    return this.element.querySelector('[data-day-index].bg-primary-600') !== null
  }

  selectDay(dayIndex) {
    const pill = this.element.querySelector(`[data-day-index="${dayIndex}"]`)
    if (!pill || pill.classList.contains("bg-primary-600")) return
    pill.classList.add("bg-primary-600", "text-white")
    pill.classList.remove("bg-neutral-100", "text-neutral-700")
    this.addHiddenInput(dayIndex)
  }

  deselectDay(dayIndex) {
    const pill = this.element.querySelector(`[data-day-index="${dayIndex}"]`)
    if (!pill) return
    pill.classList.remove("bg-primary-600", "text-white")
    pill.classList.add("bg-neutral-100", "text-neutral-700")
    this.removeHiddenInput(dayIndex)
  }

  addHiddenInput(dayIndex) {
    const existing = this.hiddenContainerTarget.querySelector(`input[data-day-value="${dayIndex}"]`)
    if (existing) return
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "appointment[days_of_week][]"
    input.value = dayIndex
    input.dataset.dayValue = dayIndex
    this.hiddenContainerTarget.appendChild(input)
    this.notifyChange()
  }

  removeHiddenInput(dayIndex) {
    const existing = this.hiddenContainerTarget.querySelector(`input[data-day-value="${dayIndex}"]`)
    if (existing) existing.remove()
    this.notifyChange()
  }

  notifyChange() {
    this.element.dispatchEvent(new CustomEvent("day-picker:change", { bubbles: true }))
  }
}
